export const updateTotalAmountToText = (val: number | undefined, isError?: unknown): string => {
    if (isError || !val) return ' ';
    return val
        .toLocaleString()
        .replace(',', '.')
        .replace(/.(?=[^.]+$)/, ',');
};
